module.exports = {
  WBI: "WBI",
  WBS: "WBS",
  WBR: "WBR",
  WBT: "WBT",
};
